import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import { PopperTooltip } from "~/common/components/Tooltip";
import { useTranslation } from "react-i18next";
import { type ReactNode, useState } from "react";
import { type IconSize } from "~/common/components/icon/IconSize";
import classNames from "classnames";
import classes from "~/features/productDetails/components/CopyToClipboard.module.less";

interface CopyClipboardProps {
  className?: string;
  side?: "left" | "right" | "bottom" | "top";
  iconSize?: IconSize;
  text: string;
}

const CopyToClipboard = (props: CopyClipboardProps) => {
  const { className, side = "bottom", iconSize, text } = props;
  const { t } = useTranslation();

  const copyMessage = <span>{t("generic.copyToClipboard")}</span>;
  const [tooltip, setTooltip] = useState<ReactNode>(copyMessage);

  const resetTooltipContent = () => {
    setTooltip(copyMessage);
  };

  const copyClipboard = () => {
    navigator.clipboard.writeText(text);
    const copiedMessage = (
      <div className={classes.copiedCheckIcon}>
        <Icon type={IconType.Check} />
        {t("generic.copiedToClipboard")}
      </div>
    );
    setTooltip(copiedMessage);
  };

  return (
    <PopperTooltip
      className={classNames(classes.clipboardIcon, className)}
      innerClassName={classes.popupInner}
      tooltipContent={tooltip}
      placement={side}
      onTooltipClosed={resetTooltipContent}
    >
      <Icon className="f-green" type={IconType.CopyToClipboard} size={iconSize} onClick={copyClipboard} />
    </PopperTooltip>
  );
};

export default CopyToClipboard;
